import { atom } from "recoil";

export const isGApiInitializedAtom = atom({
    key: "isGApiInitializedAtom",
    default: false,
});
